import React from 'react';

import { Group, ScrollArea, Skeleton, Stack, Table } from '@mantine/core';

import styles from '../PatientListPage.module.scss';
import TableHeader from '../TableHeader';

interface TableSkeletonProps {
  rows?: number;
}

const PatientRowSkeleton: React.FC = () => (
  <Table.Tr>
    {/* Patient Cell */}
    <Table.Td>
      <Group gap={4}>
        <Skeleton height={14} width="70%" />
      </Group>
    </Table.Td>
    <Table.Td>
      <Stack gap={4}>
        <Skeleton height={16} width="60%" />
        <Skeleton height={12} width="80%" />
      </Stack>
    </Table.Td>

    <Table.Td>
      <Group gap={4}>
        <Skeleton height={14} width="70%" />
      </Group>
    </Table.Td>

    {/* Clinic Cell */}
    <Table.Td>
      <Group gap={4}>
        <Skeleton height={14} width="70%" />
      </Group>
    </Table.Td>

    {/* Last Transmission Cell */}
    <Table.Td>
      <Skeleton height={14} width="60%" />
    </Table.Td>

    {/* Previous Report Cell */}
    <Table.Td>
      <Group gap={8}>
        <Skeleton height={20} width={60} radius="sm" />
        <Skeleton height={12} width="50%" />
        <Skeleton height={18} width={30} radius="sm" />
      </Group>
    </Table.Td>

    {/* Current Report Cell */}
    <Table.Td>
      <Group gap={8}>
        <Skeleton height={20} width={60} radius="sm" />
        <Skeleton height={12} width="50%" />
        <Skeleton height={18} width={30} radius="sm" />
      </Group>
    </Table.Td>

    {/* Options Cell */}
    <Table.Td>
      <Group gap={8}>
        <Skeleton height={22} width={10} radius="sm" />
      </Group>
    </Table.Td>
  </Table.Tr>
);

export const TableSkeleton: React.FC<TableSkeletonProps> = ({ rows = 10 }) => {
  return (
    <ScrollArea h="70vh" type="always">
      <Table withTableBorder withColumnBorders>
        <TableHeader isLoading={true} />
        <Table.Tbody className={styles.tableBody}>
          {Array.from({ length: rows }).map((_, index) => (
            <PatientRowSkeleton key={index} />
          ))}
        </Table.Tbody>
      </Table>
    </ScrollArea>
  );
};

export default TableSkeleton;
